import React from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useMsal} from "@azure/msal-react";
import {loginRequest} from "../../authConfig";

export function ManagementHub() {
    const {instance} = useMsal();
    const account = useAccount();

    const loginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    return (
        <div>
            <UnauthenticatedTemplate>
                <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>
                <div className="page-title-sh26">
                    <h1>Management hub</h1>
                </div>
                <hr/>

                <div className="page-section">
                    <p>New enquiries</p>
                    {/* should have company name and date created as well as a view details button */}
                </div>
                <br/>

                <div className="page-section">
                    <p>New designs</p>
                    {/* should have company name and date created as well as a view details button */}
                </div>
                <br/>

                <div className="page-section">
                    <p>New print files</p>
                    {/* should have company name and date created as well as a view details button */}
                </div>
                <br/>
            </AuthenticatedTemplate>
        </div>
    );
}
